import setIRMData from '../actions/setIRMData';
import { getStore } from '../store/composeStore';
import ComposeViewState from '../store/schema/ComposeViewState';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import strings from 'owa-strings/owa-common-strings';
import { createIRMData } from '../actions/protectMessage';
import * as React from 'react';

export function createModifyProtectionInfoBarCustomAction(
    viewState: ComposeViewState
): InfoBarCustomAction {
    return {
        text: strings.cmpEncryptionChangePermissions,
        action: () => {
            showModifyProtectionDialog(viewState);
        },
    };
}

async function showModifyProtectionDialog(viewState: ComposeViewState) {
    const templates = getStore().complianceConfigurations;

    //TODO: Replace with default if exists.
    let selectedTemplate = viewState.IRMData ? viewState.IRMData.RmsTemplateId : undefined;

    if (
        DialogResponse.ok ==
        (await confirm(
            strings.cmpEncryptionChangePermissions,
            strings.cmpEncryptionChangePermissionsDescription,
            false /*resolveImmediately*/,
            {
                okText: strings.okButton,
                cancelText: strings.cancelButton,
                bodyElement: (
                    <div>
                        <Dropdown
                            defaultSelectedKey={selectedTemplate}
                            onChanged={item => {
                                selectedTemplate = item.key.toString();
                            }}
                            options={[...templates.entries()].map(entry => ({
                                key: entry[0],
                                text: entry[1].TemplateName,
                            }))}
                        />
                    </div>
                ),
            }
        ))
    ) {
        setIRMData(viewState, createIRMData(viewState, templates.get(selectedTemplate)));
    }
}
